import firebaseConfig from "../../firebaseConfig"
import firebase from "firebase/app"
import "firebase/firestore"

const firebaseApp = firebase.initializeApp(firebaseConfig)

// TODO: Auth.
export default firebaseApp.firestore()
